import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const login = async (user) => {
  const response = await axios.post(`${base_url}user/admin-login`, user);
  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data;
};

const getSubscribers = async () => {
  const response = await axios.get(`${base_url}user/subscribers`);
  return response.data;
};

const sendMarketingEmail = async (data) => {
  const response = await axios.post(`${base_url}user/send-marketing-email`, data, config);
  return response.data;
};

const deleteSubscriber = async (id) => {
  const response = await axios.delete(`${base_url}user/subscribers/${id}`, config);
  return response.data;
};

const authService = {
  login,
  getSubscribers,
  sendMarketingEmail,
  deleteSubscriber,
};

export default authService;
